import { render, staticRenderFns } from "./BotTable.vue?vue&type=template&id=78d1f777&scoped=true&"
import script from "./BotTable.vue?vue&type=script&lang=js&"
export * from "./BotTable.vue?vue&type=script&lang=js&"
import style0 from "./BotTable.vue?vue&type=style&index=0&id=78d1f777&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d1f777",
  null
  
)

export default component.exports